import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { Avatar, Box, Button, Container, Divider, Grid, IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDirections, faLink, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import moment from "moment";
import 'moment/locale/es';

import ShareButton from "../../../components/ShareButton";
import { FacebookShareButton, TelegramShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import ReactPlayer from "react-player";
import '../../../App.css'

import { domain, imagesURL } from "../../../apiRoutes/apiBase";
import QUDProgress from "../../../components/progress";
import ResponseComponent from "../../../components/responseComponent";
import { formatStringWithHyphens } from "../../../controllers/AuxController";
import { Helmet, HelmetData } from "react-helmet-async";
import { createView } from "../../../controllers/customer/ViewsController";
import { GetEventByID } from "../../../controllers/customer/EventosController"; // Ajusta a tu nueva ruta pública

moment.locale('es');

const helmetData = new HelmetData({});

export default function EventsDetails() {
    // Inicializamos como objeto vacío para que no falle al intentar leer propiedades
    const [event, setEvent] = useState({}); 
    const [tickets, setTickets] = useState([]);

    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');

    const [isLoadingData, setIsLoadingData] = useState(false);

    const { id } = useParams();
    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route);
    };

    useEffect(() => {
        handleGetEvent();
        window.scrollTo(0, 0);
    }, []);

    const handleGetEvent = async () => {
        setIsLoadingData(true);
        let response = await GetEventByID(id);
        
        if (response.success === true) {
            setEvent(response.data.event);
            setTickets(response.data.tickets);
            // Usamos el UUID del merchant que ahora viene anidado
            createView('event', id, response.data.event.merchant.uuid); 
        }
        setIsLoadingData(false);
        window.scrollTo(0, 0);
    };

    const handleCopy = () => {
        const url = `${domain}eventos/${event.id}?event=${formatStringWithHyphens(event.name)}`;
        navigator.clipboard.writeText(url);
        
        setSuccess(true);
        setMessage('Enlace copiado exitosamente');
        setShow(true);
    };

    // Evitamos renderizar hasta que exista el evento
    if (!event.id && !isLoadingData) return null;

    const eventURL = event.id ? `${domain}eventos/${event.id}?event=${formatStringWithHyphens(event.name)}` : '';

    return (
        <>
            {
                event.id &&
                <Helmet helmetData={helmetData}>
                    <title>Eventos - {event.name}</title>
                    <meta name="description" content={event.description} />
                </Helmet>
            }
            
            <QUDProgress open={isLoadingData} />
            <ResponseComponent
                show={show}
                success={success}
                message={message}
                actionText='Finalizar'
                onClick={() => setShow(false)}
            />

            {/**Portada */}
            {event.id && (
                <Box
                    sx={{
                        backgroundImage: `url(${imagesURL}eventos/${encodeURIComponent(event.image)})`,
                        backgroundPosition: 'top',
                        height: { lg: '70vh', xl: '55vh' },
                        width: '100%',
                        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                    }}
                >
                    <Helmet prioritizeSeoTags>
                        <title>{event.name} - QUD</title>
                        {event.description && <meta name="description" content={event.description.replace(/<[^>]+>/g, '').substring(0, 150)} />}
                    </Helmet>
                    <Box
                        sx={{
                            width: '100%', height: '100%', bgcolor: '#00000060', backdropFilter: 'blur(20px)',
                            display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'
                        }}
                    >
                        <Container sx={{ mb: -5, color: '#FFF' }}>
                            <Grid container spacing={3} mt={3} alignItems={'center'}>
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                    <Box 
                                        sx={{
                                            width: '100%', position: 'relative', paddingBottom: '100%', 
                                            borderRadius: 2, overflow: 'hidden'
                                        }}
                                    >
                                        <img
                                            style={{
                                                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                                objectFit: 'cover', borderRadius: 20
                                            }}
                                            src={imagesURL + 'eventos/' + event.image}
                                            alt={event.name}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container spacing={3} alignItems={'center'}>
                                            <Grid item xl={2}>
                                                <Avatar variant="rounded" sx={{ bgcolor: '#FFF', color: '#000', width: 80, height: 80, display: 'flex', flexDirection: 'column', borderRadius: 2 }}>
                                                    <Typography variant='h5' fontWeight={'bold'}>
                                                        {moment(event.date).format('MMM')}
                                                    </Typography>
                                                    <Typography variant='h5' fontWeight={'bold'}>
                                                        {moment(event.date).format('D')}
                                                    </Typography>
                                                </Avatar>
                                            </Grid>
                                            <Grid item xl={10}>
                                                <Typography variant="h5">
                                                    {event.city}
                                                </Typography>
                                                <Typography variant="h6">
                                                    <FontAwesomeIcon icon={faLocationDot} />  {event.address}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                        <Typography variant="h4" fontWeight={'bold'}>
                                            {event.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ bgcolor: '#FFFFFF50', borderRadius: 2, mb: { xs: 8 } }} mt={2} p={2}>
                                        <Grid container spacing={3} alignItems={'center'}>
                                            <Grid item xs={12} lg={6} xl={6}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={3} sm={2} md={2} lg={3} xl={3}>
                                                        <Typography fontWeight={'bold'}>Compartir</Typography>
                                                    </Grid>
                                                    <Grid item xs={9} sm={10} md={10} lg={9} xl={9} display={'flex'} flexDirection={'row'}>
                                                        <FacebookShareButton url={eventURL}>
                                                            <FontAwesomeIcon size="lg" icon={faFacebookF} />
                                                        </FacebookShareButton>

                                                        <TwitterShareButton url={eventURL} style={{ marginLeft: 15 }}>
                                                            <FontAwesomeIcon size="lg" icon={faTwitter} />
                                                        </TwitterShareButton>

                                                        <WhatsappShareButton url={eventURL} style={{ marginLeft: 15 }}>
                                                            <FontAwesomeIcon size="lg" icon={faWhatsapp} />
                                                        </WhatsappShareButton>

                                                        <TelegramShareButton url={eventURL} style={{ marginLeft: 15 }}>
                                                            <FontAwesomeIcon size="lg" icon={faTelegram} />
                                                        </TelegramShareButton>

                                                        <IconButton style={{ marginLeft: 10 }} onClick={handleCopy}>
                                                            <FontAwesomeIcon size="xs" color="#FFF" icon={faLink} />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} lg={6} xl={6} justifyContent={'flex-end'}>
                                                <Button fullWidth variant="contained" color="link" onClick={() => redireccionar('/eventos/' + event.id + '/tickets')}>
                                                    {/* BOTÓN DINÁMICO: Lee la bandera is_free que mandamos del backend */}
                                                    <Typography variant="h6">{event.is_free ? 'Obtener' : 'Comprar'} tickets</Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>
                </Box>
            )}

            {/**Detalles del evento */}
            <Container sx={{ mt: 10 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6">Detalles</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
                        <Typography variant="h6" fontWeight={'bold'}>Fecha {event.end_date && 'Inicio'}</Typography>
                        <Typography variant="h6">{moment(event.date).format("DD MMMM YYYY")}</Typography>
                    </Grid>

                    {event.end_date && (
                        <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
                            <Typography variant="h6" fontWeight={'bold'}>Fecha Fin</Typography>
                            <Typography variant="h6">{moment(event.end_date).format("DD MMMM YYYY")}</Typography>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
                        <Typography variant="h6" fontWeight={'bold'}>Apertura</Typography>
                        <Typography variant="h6">{event.opening_time}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
                        <Typography variant="h6" fontWeight={'bold'}>Inicio</Typography>
                        <Typography variant="h6">{event.start_time}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                        <Typography variant="h6" fontWeight={'bold'}>Edad</Typography>
                        <Typography variant="h6">{event.age_limit}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                        <Typography variant="h6" fontWeight={'bold'}>Asientos</Typography>
                        <Typography variant="h6">{event.capacity}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
                        <Divider />
                    </Grid>
                </Grid>
            </Container>

            {/**Descripcion del evento */}
            <Container sx={{ mt: 5 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6">Descripción</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={7} xl={7} sx={{ fontSize: '16px !important' }}>
                        {event.description && (
                            <ReactQuill 
                                className="my-quill-container"
                                theme={'bubble'} 
                                readOnly={true} 
                                modules={{ toolbar: false }} 
                                value={event.description}
                            />
                        )}
                    </Grid>
                    {event.youtube_url && (
                        <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                            <Box sx={{ width: '100%' }}>
                                <ReactPlayer width={'100%'} url={event.youtube_url} />
                            </Box>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
                        <Divider />
                    </Grid>
                </Grid>
            </Container>

            {/**Direccion del evento */}
            <Container sx={{ mt: 5 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6">Dirección</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                        <Typography variant="h6">{event.address}</Typography>
                        <Button
                            startIcon={<FontAwesomeIcon icon={faDirections} />}
                            target="_blank"
                            color="link"
                            href={`http://googleusercontent.com/maps.google.com/maps?q=${encodeURIComponent(event.address)}`}
                        >
                            <Typography>Cómo llegar</Typography>
                        </Button>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
                        <Divider />
                    </Grid>
                </Grid>
            </Container>

            {/**Contacto del evento */}
            <Container sx={{ mt: 5, mb: 10 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6">¿Tienes preguntas sobre el evento?</Typography>
                    </Grid>

                    {event.merchant && (
                        <>
                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                <Typography variant="h6" fontWeight={'bold'}>Contáctanos</Typography>
                                <Button color="primary" onClick={() => redireccionar(`/merchants/${event.merchant.uuid}/profile`)}>
                                    <Typography variant="h6">{event.merchant.name}</Typography>
                                </Button>   
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                <Typography variant="h6" fontWeight={'bold'}>Teléfono</Typography>
                                <Button href={`tel:${event.merchant.phone}`} target="_blank" color="primary">
                                    <Typography variant="h6">{event.merchant.phone}</Typography>
                                </Button>   
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                <Typography variant="h6" fontWeight={'bold'}>Whatsapp</Typography>
                                <Button href={`https://wa.me/${event.merchant.phone?.replace(/[^0-9]/g, '')}`} target="_blank">
                                    <Typography variant="h6">{event.merchant.phone}</Typography>
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3} alignItems={'center'}>
                                <Button fullWidth variant="contained" color="link" onClick={() => redireccionar(`/merchants/${event.merchant.uuid}/profile`)}>
                                    <Typography variant="h6">Visitar perfil de {event.merchant.name}</Typography>
                                </Button>
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
                        <Divider />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}